(() => {
  function init(scope=document) {
    const gallery=scope.querySelector('[data-joe-gallery]');
    if(!gallery || gallery.dataset.initialized) return;
    gallery.dataset.initialized='true';
    const container=gallery.closest('[data-section-type="product"]');
    const config=JSON.parse(container.querySelector('[data-joe-config]').textContent);
    const main=gallery.querySelector('[data-joe-main]'),thumbs=gallery.querySelector('[data-joe-thumbs]');
    let current=config.variants.find(v=>String(v.id)===gallery.dataset.joeVariant);
    function show(file,label) {
      main.src=config.media[file]+'&width=1200';
      main.srcset=config.media[file]+'&width=600 600w, '+config.media[file]+'&width=1200 1200w';
      main.sizes='(max-width: 749px) calc(100vw - 40px), 50vw';
      main.alt=config.title+' – '+current.title+' – '+label;
    }
    function update(variant) {
      if(!variant) return;
      current=variant;
      const color=variant.option1.toLowerCase(),size=variant.option2.slice(0,1).toLowerCase();
      const files=[color+'-groesse-'+size+'.png','anwendung-'+color+'.jpeg',color+'-groessen-masse.png',color+'-groessenvergleich-stapel.png','material.jpeg','sam-detail.jpeg'];
      show(files[0],config.labels[0]);
      thumbs.replaceChildren(...files.map((file,index)=>{
        const label=config.labels[[0,3,1,2,4,5][index]];
        const button=document.createElement('button'),image=document.createElement('img');
        button.type='button';button.setAttribute('aria-label',label);button.setAttribute('aria-pressed',index===0);
        image.src=config.media[file]+'&width=140';image.alt='';image.width=68;image.height=68;image.loading='lazy';button.append(image);
        button.addEventListener('click',()=>{show(file,label);thumbs.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',b===button));});return button;
      }));
      document.querySelectorAll('#joe-size-comparison').forEach(image=>{image.src=config.media[color+'-groessen-masse.png']+'&width=1200';image.srcset=config.media[color+'-groessen-masse.png']+'&width=600 600w, '+config.media[color+'-groessen-masse.png']+'&width=1200 1200w';image.sizes='(max-width: 749px) calc(100vw - 40px), 900px';});
    }
    container.addEventListener('variantChange',event=>update(event.detail.variant));
    document.addEventListener('click',event=>{
      const action=event.target.closest('[data-joe-size],[data-joe-color]');if(!action)return;
      const option=action.dataset.joeColor || action.dataset.joeSize;
      const input=[...container.querySelectorAll('[data-variant-input]')].find(el=>action.dataset.joeColor?el.value===option:el.dataset.index==='option2' && el.value.slice(0,1)===option);
      if(input && !input.disabled){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    update(current);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',()=>init());
})();


